<!--
 * @Description: 页面名称
 * @Autor: kangcheng
 * @Date: 2024-01-04 13:56:44
 * @LastEditors: kangcheng
 * @LastEditTime: 2024-01-08 11:02:11
-->
<template>
  <div id="app">
    <router-view v-if="languageAll"></router-view>
    <!-- <appTabar v-show="$route.meta.isShow"></appTabar> -->
    <!-- <div class="loading" v-show="this.$store.state.loadingShow">
      <van-loading type="spinner" color="#1989fa" size="50px" />
    </div> -->
  </div>
</template>
<script>
import "@/vantui";
// import appTabar from "@/components/appTabar.vue";
export default {
  components: {
    // appTabar,
  },

  methods: {
    // getParams() {
    //   hydra.customPlugin({
    //     action: "UtilPlugin.getAppConfig",
    //     params: {},
    //     success(res) {
    //       if (res.flag) {
    //         self.hintOutput = true;
    //         self.hintInput = true;
    //       }

    //     },
    //     fail(msg) {
    //       this.$toast(msg);
    //     },
    //   });
    // },
    getParams() {
      // let params = {};
      if (navigator.userAgent.indexOf("iflytek_mmp.linkmessenger") != -1) {
        // console.log("初始化");
        this.$store.dispatch("common/setParams", 1);
      } else {
        this.$store.dispatch("common/setParams", 2);
      }
      // this.$store.dispatch("common/setParams");
      this.$store.dispatch("common/setLanguage");
      // console.log(this.$store.state);
      // console.log(this.$store.dispatch.setParams, "sss");
    },
  },
  mounted() {
    // this.getParams();
  },
  created() {
    console.log(window.configOption.baseUrl, "111111");
    this.getParams();
  },
  computed: {
    languageAll() {
      return this.$store.state.common.languageAll;
    },
  },
};
</script>
<style lang="less">
#app {
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #fff;
  height: 100%;
  font-size: 0.14rem;
}
body,
html {
  height: 100%;
}
html {
  font-size: 100px !important;
}
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.loading {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 97;
  .van-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.translateSelectLanguage {
  display: none !important;
}
.line1 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1; /* 控制显示的行数 */
  -webkit-box-orient: vertical;
}
</style>

